<template>
  <div class="invite-friend">
    <img src="@assets/images/invite-b.png" alt="">
	<div class="invite-view">
		<img src="@assets/images/invite-title.png" alt="">
		<div
		  class="invite-view-copy"
		  :data-clipboard-text="copyUrl"
		>
		  复制链接
		</div>
		<div class="invite-view-poster" @click="$router.push('/user/poster')">图文邀请卡</div>
	</div>
	<div class="invite-list">
		<div class="invite-list-title">我已邀请9人</div>
		<ul>
			<li>
				<div>
					<img src="@assets/images/invite-b.png" alt="">
					姓名
				</div>
				<div>获得<strong>00.98</strong>元</div>
			</li>
			<li class="invite-list-last" @click="$router.push('/user/promoter_invite/total')">查看我的邀请</li>
		</ul>
	</div>
  </div>
</template>
<script>
import ClipboardJS from "clipboard";
export default {
  name: "InviteFriend",
  components: {},
  props: {},
  data: function() {
    return {
	  copyUrl:'http://baidu.com'
    };
  },
  watch: {
    $route(n) {
      
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      var copybtn = document.getElementsByClassName("invite-view-copy");
      const clipboard = new ClipboardJS(copybtn);
      clipboard.on("success", () => {
        this.$dialog.success("复制成功");
      });
    });
  },
  methods: {
    
  }
};
</script>
<style scoped>
.invite-friend{background-color: #fff4ea;}
img{display: block;width: 100%;}
.invite-view{margin-top: -2rem;position: relative;padding: 0 0.1rem;}
.invite-view-copy,.invite-view-poster{width: 2.8rem; height: 0.6rem;line-height: 0.6rem;background-color: #fd912e;color: #fff;border-radius: 17px;position: absolute;padding: 0 0.4rem 0 0.9rem;}
.invite-view-copy{left: 9%;bottom: 17%;}
.invite-view-poster{right: 9%;bottom: 17%;}
.invite-view-copy::before,.invite-view-poster::before{
	content: "";
	position: absolute;
	top: 10%;
	left: 15%;
	width: 0.3rem;
	height: 0.3rem;
	transform: translateY(20%);
}
.invite-view-copy::before{
	background: url(../../../assets/images/invite-cp.png) no-repeat 50%;
	background-size: 100%;
}
.invite-view-poster::before{
	background: url(../../../assets/images/invite-poster.png) no-repeat 50%;
	background-size: 100%;
}
.icon-haibao{color: #fff;}
.invite-list{padding: 0 0.3rem;}
.invite-list-title{background: url(../../../assets/images/invite-header.png) no-repeat;background-size: 100% 100%;padding: 0.2rem 0;text-align: center;color: #fd7226;font-weight: bold;}
.invite-list ul{background-color: #fff;padding: 0.3rem;margin-bottom: 0.3rem;border-radius: 7px;}
.invite-list ul li{padding: 0.1rem 0;display: flex;justify-content: space-between;}
.invite-list ul li>div:last-child{font-size: 0.26rem;}
.invite-list ul li img{width: 0.5rem;height: 0.5rem;border-radius: 50%;display: inline-block;vertical-align: middle;}
.invite-list ul li strong{color: #fd7226;font-size: 0.28rem;}
.invite-list ul li.invite-list-last{justify-content: center;color: #fd7226;text-decoration: underline;font-size: 0.26rem;}
</style>
